import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchPlace from "../models.machine/DtoSelectSearchPlace";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchPlace from "../models.machine/DtoPageListSearchPlace";
import DtoPageListPlace from "../models.machine/DtoPageListPlace";
import UiDrag from "../models.machine/UiDrag";
import DtoDetailPlace from "../models.machine/DtoDetailPlace";
import DtoFormPlace from "../models.machine/DtoFormPlace";

/**
 * 详细产地
 * @description 自动生成的代码,请勿修改
 */
export default class PlaceAppService {
    /**
     * 获取航线代码选择器
     * @param {DtoSelectSearchPlace} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchPlace): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/Place/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取详细产地分页列表
     * @param {DtoPageListSearchPlace} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListPlace>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchPlace): AxiosPromise<RESTfulResult<DtoPageListPlace>> {
        const url = `/api/Place/Get`;
        return service.get<RESTfulResult<DtoPageListPlace>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/Place/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取详细产地详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailPlace>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailPlace>> {
        const url = `/api/Place/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailPlace>>(url);
    }

    /**
     * 新增/编辑详细产地
     * @param {DtoFormPlace} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Post(dto?: DtoFormPlace): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/Place/Post`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 批量删除详细产地
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/Place/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 导出
     * @param {string} [name] 
     * @param {string[]} [ids] 
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static PostExportExceByName(name?: string, ids?: string[]): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/Place/PostExportExce/${name}`;
        return service.post<RESTfulResult<string>>(url, ids);
    }

    /**
     * 导出导入模板
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static GetExportImportTemplate(): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/Place/GetExportImportTemplate`;
        return service.get<RESTfulResult<string>>(url);
    }

    /**
     * 导入
     * @param {any} [file] 
     * @returns {AxiosPromise<RESTfulResult<boolean>>} 
     */
    static PostImport(file?: any): AxiosPromise<RESTfulResult<boolean>> {
        const url = `/api/Place/PostImport`;
        return service.post<RESTfulResult<boolean>>(url, file);
    }

    /**
     * 获取Name数组，用于重复判断
     * @returns {AxiosPromise<RESTfulResult<string[]>>} 
     */
    static GetNameList(): AxiosPromise<RESTfulResult<string[]>> {
        const url = `/api/Place/GetNameList`;
        return service.get<RESTfulResult<string[]>>(url);
    }

    /**
     * 同步详细产地
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static SyncData(): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/Place/SyncData`;
        return service.post<RESTfulResult<any>>(url);
    }

}
